module.exports = __webpack_public_path__ + "static/customer_1inch_logo-614ceb1192a57713f161d7b0b477b32c.svg";